module.exports = __webpack_public_path__ + "static/img/HOMEPAGE_desktop_background_gold.4d198ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HOMEPAGE_desktop_background_gold.png
// module id = ZAVy
// module chunks = 0